<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" class="cursor-pointer">
        mdi-dots-horizontal
      </v-icon>
    </template>

    <v-list dense>
      <template v-for="(action, index) in normalizedActions">
        <v-divider v-if="action.divider" :key="`divider-${index}`" />

        <v-list-item
          v-else
          :key="`action-${index}`"
          :disabled="action.disabled"
          @click="onActionClick(action)"
        >
          <v-list-item-icon v-if="action.icon">
            <v-icon :color="action.iconColor || undefined">
              {{ action.icon }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-title :class="action.textClass || ''">
            {{ action.label }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "BaseRowActionsMenu",
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    normalizedActions() {
      return Array.isArray(this.actions) ? this.actions : [];
    },
  },
  methods: {
    onActionClick(action) {
      if (!action || action.disabled || typeof action.onClick !== "function") {
        return;
      }

      action.onClick();
    },
  },
};
</script>
